import React, { useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ChamadoModal from '../ChamadoModal/ChamadoModal';
import styles from './ChamadoFloatButton.module.css';

// paths onde o botão NÃO deve aparecer
const HIDDEN_PATHS = ['/login', '/register', '/trocar-senha'];
const HIDDEN_PREFIXES = ['/catalogo/', '/pdv', '/precaixa'];

const ChamadoFloatButton = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [toast, setToast] = useState({ show: false, text: '' });

  const handleSuccess = (chamado) => {
    setShow(false); // fecha o modal imediatamente
    const ref = chamado?.numero || (chamado?.id ? `#${chamado.id}` : '');
    setToast({ show: true, text: `Chamado ${ref} aberto com sucesso!`.replace('  ', ' ') });
  };

  // Ocultar em rotas públicas e PDV
  const path = location.pathname;
  const esconder =
    !user ||
    HIDDEN_PATHS.includes(path) ||
    HIDDEN_PREFIXES.some(p => path.startsWith(p));

  if (esconder) return null;

  return (
    <>
      <button
        className={styles.fab}
        onClick={() => setShow(true)}
        title="Abrir chamado de suporte"
        aria-label="Abrir chamado de suporte"
      >
        {/* HelpCircle via SVG inline — lucide-react pode não estar instalado; SVG é zero-dep */}
        <svg
          className={styles.fabIcon}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <span className={styles.tooltip}>Abrir chamado</span>
      </button>

      {show && (
        <ChamadoModal
          show={show}
          onHide={() => setShow(false)}
          onSuccess={handleSuccess}
        />
      )}

      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 1100 }}>
        <Toast
          show={toast.show}
          onClose={() => setToast({ show: false, text: '' })}
          bg="success"
          delay={4000}
          autohide
        >
          <Toast.Header closeButton>
            <strong className="me-auto">Chamado aberto</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toast.text}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default ChamadoFloatButton;
